<template>
  <div class="full">
    <div class="header">
      <div class="person">
        <img src="@/assets/image/message/tou.png" alt="头像">
        <div class="perMes">
          <p class="name">{{ this.$store.state.user.user_name || 'XXX' }}</p>
          <p class="exma_id">{{this.$store.state.user.user_id_no || '111111111111111111'}}</p>
        </div>
        <span class="tit">
          {{ this.$store.state.project.project_name }}<br>
          <label class="subject_name">主观题部分（{{ this.$store.state.exam.cur_subject.subject_name }}）</label>
        </span>
      </div>
      <div class="exam_detail">
        <div class="exam_msg">
          <p>机位：111</p>
          <p>剩余时间：{{ timer }}</p>
        </div>
        <button class="btn submit" type="button" @click="submit">交卷</button>
      </div>
    </div>
    <div class="main exam_body" :class="curySkin">
      <div class="main-top" :class="{
        fullScreen: is_full,
        folatScreen: is_float
      }">
        <div class="top-left" :style="{ width: is_float ? '100%' : lrDownX }">
          <div class="tl-top">
            <div class="cailiao-wrap">
              <!-- <button class="tips-btn" @click="showExamNote">注意事项</button>
              <span class="cailiao-title">材料：</span>
              <button v-for="(que, index) in part.description" :key="`cailiao${index}`" class="cailiao-btn"
                :class="index >= 9 ? 'flexCent' : ''" @click=changeCaiLiao(index);>{{ index + 1 }}</button> -->
            </div>
            <div class="tools-wrap">
              <button class="tools-btn zoom-up" @click="cailiaoZoomUp"></button>
              <button class="tools-btn zoom-down" @click="cailiaoZoomDown"></button>
              <button class="tools-btn text-stress" @click="highlight('yellow')"></button>
              <button class="tools-btn text-noStress" @click="highlight('transparent')"></button>
            </div>
          </div>
          <div class="tl-main" oncopy="return false" oncontextmenu="return false">
            <div>
              <div :style="{
                fontSize: cailiaoConfig.contFontSize + 'px'
              }">
                <p class="tl-note-title">注意事项：</p>
                <div v-html="part.take_care_note"></div>
                <br />
              </div>
              
              <div v-for="(que, index) in topic.descriptions" :key="`cont${index}`">
                <p class="tl-main-title" :id="`title${index}`" :style="{
                  fontSize: cailiaoConfig.titleFontSize + 'px'
                }" v-html="que.title">
                  
                </p>
                <div class="tl-main-content" style="text-indent:2em;" :style="{
                  fontSize: cailiaoConfig.contFontSize + 'px'
                }" v-html="que.content">
                </div>
                <br />
              </div>
            </div>
          </div>
        </div>
        <div v-if="!is_full && !is_float" class="top-left-scroll" @mousedown="lrScrollDown"></div>
        <div class="top-right" :style="{ width: is_full ? '100%' : `calc(100% - ${lrDownX})` }" v-if="!is_float">
          <doanswer ref="doanswer" :is_full.sync="is_full" :is_float.sync="is_float" :curySkin="curySkin" :topic="topic"
            :cur_question_id="cur_question_id"></doanswer>
        </div>
      </div>
      <div class="main-bottom">
        <div class="bottom-left">
          <button class="skin-btn skin1" @click="changeSkin('skin1')"></button>
          <button class="skin-btn skin2" @click="changeSkin('skin2')"></button>
          <button class="skin-btn skin3" @click="changeSkin('skin3')"></button>
          <button class="skin-btn skin4" @click="changeSkin('skin4')"></button>
          <button class="skin-btn skin5" @click="changeSkin('skin5')"></button>
          <button class="skin-btn skin6" @click="changeSkin('skin6')"></button>
        </div>
        <div class="bottom-right">
          <button v-for="que in part.questions" :key="que.question_id" class="que-but" :class="{
            finished: getTopicAnserLast(que.question_id).answer,
            selected: topic.question_id === que.question_id
          }" @click="changeTopic(que)">{{ `问题${que.topic_num}` }}</button>
          <span class="prim-but" @click="changeInputMethod">切换输入法</span>
        </div>
      </div>
    </div>
    <float-do-ans :curySkin="curySkin" :is_show.sync="is_float" :topic="topic" :cur_question_id="cur_question_id"
      :is_full="true" @cancleFloat="cancleFloat" @fullScreen="fullScreen"></float-do-ans>
  </div>
</template>

<script>
import questionData from "@/infrastructures/api/question2.json"
import Doanswer from "@/components/paper/doanswer"
import FloatDoAns from "@/components/paper/floatDoAns"

export default {
  name: 'Exam2',
  components: { Doanswer, FloatDoAns },
  data () {
    return {
      curySkin: 'skin1',
      lrScroll: false,
      lrDownX: '50%',
      part: [],//试题部分
      cur_question_id: "", //当前题的id
      topic: {}, //当前题，渲染题目用
      cailiaoConfig: {
        titleFontSize: 20,
        contFontSize: 20
      },
      is_full: false, //是否全屏
      is_float: false, //是否漂浮
      all_question: [], //提取出来的所有试题
      timer: "", //默认显示的倒计时
      set_timer: null
    }
  },
  computed: {
    //答案集合
    answerItem () {
      return this.$store.state.answer;
    },
    //params[0] 试题id  返回试题最后保存的答案json
    getTopicAnserLast () {
      return function (question_id) {
        let answer = this.answerItem[question_id];
        answer = answer ? JSON.parse(JSON.stringify(answer)) : {};
        answer = answer instanceof Array ? answer.reverse()[0] : {};
        return answer
      }
    }
  },
  created () {
    document.addEventListener('keydown', function (event) {
      if ((event.ctrlKey === true || event.metaKey === true) && (event.which === 189 || event.which === 187 || event.which === 173 || event.which === 61 || event.which === 107 || event.which === 109)) {
        event.preventDefault();
      }
    });
    this.getPaper();
    this.examCountDown();
  },
  mounted () {

  },
  watch: {

  },
  beforeDestroy () {
    clearTimeout(this.set_timer);
  },
  methods: {
    // 皮肤切换
    changeSkin (skin) {
      this.curySkin = skin
    },
    // 左右拖拽
    lrScrollDown () {
      this.lrScroll = true;
      document.addEventListener('mousemove', this.lrScrollMove);
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';
      document.addEventListener('mouseup', this.lrScrollUp)
    },
    lrScrollMove (event) {
      if (this.lrScroll) {
        this.lrDownX = (event.pageX - 1) + 'px';
        if (this.$refs.doanswer) {
          this.$refs.doanswer.zoomJustCb();
        }
      }
    },
    lrScrollUp () {
      this.lrScroll = false;
      document.removeEventListener('mousemove', this.lrScrollMove);
      document.removeEventListener('mouseup', this.lrScrollUp);
      document.body.style.cursor = 'default';
      document.body.style.userSelect = 'initial';
    },
    // 切换输入法
    changeInputMethod () {
      this.$tip({
        text: `模拟操作系统中输入法不能选择和切换，实际考试中可以选择和切换！（系统支持的输入法有搜狗拼音输入法、微软拼音输入法和极点五笔输入法）`,
        //time:3,
        btn: ['确定']
      })
    },
    //获取当前试卷所有试题
    getPaper () {
      let paper_id = this.$store.state.exam.cur_subject.paper_id;//根据paper_id查试卷
      let res = questionData[paper_id];
      
      let questions = res.question;
      this.getAllQuestion(questions);//给试题加题号
      
      this.dealPart(res.part, this.all_question);
      this.changeTopic(this.all_question[0]);
    },
    //给试题加题号
    getAllQuestion (data) {
      var questions = JSON.parse(JSON.stringify(data));
      let index = 0;

      for (let i in questions) {
        index++;
        questions[i].topic_num = index;
      }
      this.all_question = questions;
    },
    // 将题目材料内容进行处理，并放入parts里面，各小题公用
    dealPart (part) {
      var questions = this.all_question;
      //历史原因修改了数据结构，怕引起更多修改，数据改为一开始的格式
      var parts = [];
      var parts_ = JSON.parse(JSON.stringify(part));
      for (var i in parts_) {
        parts.push(parts_[i])
      }
      // 注意：申论固定一道题，里面多个问题
      parts.forEach(part => {
        // 抽取题目下的所有问题
        const partQuestions = questions.filter(qes => part.display_order === qes.part_display_order);
        partQuestions.forEach((qes, index) => {
          if (index === 0) {
            part.description = qes.description;
          }
          qes.description = '';
        })
        part.questions = partQuestions;
      });
      this.part = parts[0] || {};
      console.log("this.part",this.part)
    },
    //切换试题，渲染当前试题
    changeTopic(item) {
      console.log("item切换试题",item,item.description)
      setTimeout(() => {
        //简答题blur需要触发保存，所以这里切换这里延时
        this.cur_question_id = item.question_id;
        this.topic = item;
      }, 10);
    },
    changeCaiLiao (index) {
      this.$nextTick(() => {
        const anchorEle = document.getElementById(`title${index}`);
        if (anchorEle) {
          anchorEle.scrollIntoView()
        }
      })
    },
    // 展示注意事项
    showExamNote () {
      this.$nextTick(() => {
        const noteTitle = document.querySelector('.tl-note-title');
        if (noteTitle) {
          noteTitle.scrollIntoView()
        }
      })
    },
    // 材料放大缩小
    cailiaoZoomUp() {
      if (this.cailiaoConfig.titleFontSize < 24) {
        this.cailiaoConfig.titleFontSize += 2;
        this.cailiaoConfig.contFontSize += 2;
      }
    },
    cailiaoZoomDown () {
      if (this.cailiaoConfig.titleFontSize > 16) {
        this.cailiaoConfig.titleFontSize -= 2;
        this.cailiaoConfig.contFontSize -= 2;
      }
    },
    highlight (color) {
      let range = null
      const sel = window.getSelection() // 选中文本
      if (sel.rangeCount && sel.getRangeAt) {
        range = sel.getRangeAt(0)
      }
      // 开启文档编辑
      document.designMode = 'on'
      if (range) {
        sel.removeAllRanges()
        sel.addRange(range)
      }
      document.execCommand('BackColor', false, color)
      document.designMode = 'off'
      // 去掉默认选中的蓝色
      window.getSelection().empty()
    },
    cancleFloat () {
      this.is_float = false;
    },
    fullScreen (isFull) {
      this.is_float = false;
      this.is_full = isFull;
      this.$nextTick(() => {
        if (isFull && this.$refs.doanswer.$refs.editor) {
          if (this.$refs.doanswer.$refs.editor.editor.fullCancleCb) {
            this.$refs.doanswer.$refs.editor.editor.fullCancleCb();
          }
        }
      })
    },
    //点击交卷
    submit () {
      // 提交前，失焦，保存一次答案
      this.$refs.doanswer.onblur();
      setTimeout(() => {
        let no_num = this.getNoDoTopicNum();
        let subject_name = this.$store.state.exam.cur_subject ? this.$store.state.exam.cur_subject.subject_name : "";
        let this_ = this;

        if (no_num == 0) {
          this.$tip({
            text: `${subject_name}全部作答完成`,
            btn: ['确定交卷', '返回作答']
          }, () => {
            this.$tip({
              text: `确定要交卷吗？`,
              btn: ['确定', '取消']
            }, () => {
              this_.endSubmit();
            })
          })
        } else {
          this.$tip({
            text: `主观题部分（${subject_name}）还有${no_num}道题未作答，请确认是否交卷！`,
            btn: ['确定交卷', '返回作答']
          }, () => {
            this.$tip({
              text: `确定要交卷吗？`,
              btn: ['确定', '取消']
            }, () => {
              this_.endSubmit();
            })

          })
        }
      }, 15)
    },
    getNoDoTopicNum () {
      //根据part计算未做的题目
      //选做多做需要提示
      let part = this.part;
      let num = 0;
      let do_num = 0;
      num += part.question_count;
      do_num += this.getPartDoNum(part.display_order);
      return num - do_num;
    },
    getPartDoNum (display_order) {
      let all_questions = this.all_question;
      let noDoNum = 0;
      all_questions.map(item => {
        if (item.part_display_order == display_order) {
          const answerObj = this.getTopicAnserLast(item.question_id);
          if (answerObj.answer) {
            noDoNum++;
          }
        }
      });
      return noDoNum;
    },
    //最终交卷方法
    endSubmit () {
      this.submitToPage();
    },
    submitToPage () {
      this.$router.push({
        name: "Success"
        , params: { project_code: this.$store.state.project.project_code }
        , query: { score: false }
      });
    },
    //考试倒计时
    examCountDown () {
      var curTime = new Date().getTime();
      var djs = this.$store.state.exam.exam_end_time - curTime;

      if (djs >= 1000) {

        var hours = parseInt((djs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = parseInt((djs % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = parseInt((djs % (1000 * 60)) / 1000);

        this.timer = `${hours}:${minutes}:${seconds}`;
        let this_ = this;
        clearTimeout(this.set_timer);
        this.set_timer = setTimeout(function () {
          this_.examCountDown();
        }, 1000)
      } else {
        this.timer = `0:0:0`;
        this.endSubmit();
      }
    }
  },
}
</script>

<style lang='scss' scoped>
.header {
  background: #1d7ecc;
  overflow: hidden;
}

.person {
  float: left;
}

.person img {
  height: 86px;
  vertical-align: middle;
}

.perMes {
  display: inline-block;
  display: inline-block;
  color: #fff;
  font-size: 16px;
  vertical-align: middle;
  padding: 0 10px;
}

.tit {
  display: inline-block;
  font-size: 18px;
  color: #fff;
  font-weight: bold;
  vertical-align: middle;
  margin-left: 25px;
}

.exam_detail {
  float: right;
}

.exam_msg {
  font-size: 18px;
  color: #fff;
  line-height: 26px;
  display: inline-block;
  vertical-align: middle;
  font-weight: bold;
}

.submit {
  margin: 20px 40px;
}

.btn {
  background: #f97217;
  width: 135px;
  height: 44px;
  font-size: 20px;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  display: inline-block;
  border: 1px solid #f97217;
  line-height: 46px;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.exam_body {
  background: #ffffff;
  border: 2px solid #d8d8d8;
  position: absolute;
  top: 86px;
  left: 0;
  right: 0;
  bottom: 0;

  &.skin1 {
    .top-left {
      .tl-main {
        background-color: #ffffff;
      }
    }

    .main-bottom {
      .bottom-left {
        .skin1 {
          border: 2px solid #9b9d9c;
        }
      }
    }
  }

  &.skin2 {
    .top-left {
      .tl-main {
        background-color: #cce9cf;
      }
    }

    .main-bottom {
      .bottom-left {
        .skin2 {
          border: 2px solid #9b9d9c;
        }
      }
    }
  }

  &.skin3 {
    .top-left {
      .tl-main {
        background-color: #c1d3d6;
      }
    }

    .main-bottom {
      .bottom-left {
        .skin3 {
          border: 2px solid #9b9d9c;
        }
      }
    }
  }

  &.skin4 {
    .top-left {
      .tl-main {
        background-color: #f4f1e9;
      }
    }

    .main-bottom {
      .bottom-left {
        .skin4 {
          border: 2px solid #9b9d9c;
        }
      }
    }
  }

  &.skin5 {
    .top-left {
      .tl-main {
        background-color: #dce2f2;
      }
    }

    .main-bottom {
      .bottom-left {
        .skin5 {
          border: 2px solid #9b9d9c;
        }
      }
    }
  }

  &.skin6 {
    .top-left {
      .tl-main {
        background-color: #f1e5c8;
      }
    }

    .main-bottom {
      .bottom-left {
        .skin6 {
          border: 2px solid #9b9d9c;
        }
      }
    }
  }

  .main-top {
    height: calc(100% - 60px);
    background-color: #adadad;
    display: flex;

    &.fullScreen {
      .top-left {
        display: none;
      }
    }

    .top-left {
      width: 50%;
      height: 100%;

      .tl-top {
        height: 46px;
        width: 100%;
        background-color: #f6f6f6;
        font-size: 16px;
        display: flex;
        align-items: center;
        user-select: none;

        .cailiao-wrap {
          display: flex;
          align-items: center;
          overflow: hidden;

          .cailiao-title {
            color: #6f6f74;
            margin-left: 10px;
            flex-shrink: 0;
          }

          .cailiao-btn {
            flex-shrink: 0;
            font-size: 18px;
            background-color: #5aa7db;
            display: flex;
            align-items: center;
            padding: 0 0 0 9px;
            box-sizing: border-box;
            width: 30px;
            height: 30px;
            color: #ffffff;
            border-radius: 50%;
            cursor: pointer;
            margin-right: 10px;
            outline: 0;
            border: none;

            &:hover {
              background-color: #6db7eb;
            }

            &:active {
              background-color: #5aa7db;
            }

            &.flexCent {
              padding-left: 0;
              justify-content: center;
            }
          }

          .tips-btn {
            flex-shrink: 0;
            font-size: 13px;
            background-color: #5aa7db;
            padding: 6px 10px;
            border-radius: 4px;
            color: #ffffff;
            cursor: pointer;
            outline: 0;
            border: none;
            width: 78px;
            margin: 0 10px;

            &:hover {
              background-color: #6db7eb;
            }

            &:active {
              background-color: #5aa7db;
            }
          }
        }

        .tools-wrap {
          flex-grow: 1;
          text-align: right;
          min-width: 136px;

          .tools-btn {
            width: 30px;
            height: 30px;
            cursor: pointer;
            outline: 0;
            border: none;
            margin-right: 4px;
          }

          .zoom-up {
            background: url(../assets/image/exam/6-default.png);
            background-size: cover;

            &:hover {
              background: url(../assets/image/exam/6-hover.png);
              background-size: cover;
            }

            &:active {
              background: url(../assets/image/exam/6-selected.png);
              background-size: cover;
            }
          }

          .zoom-down {
            background: url(../assets/image/exam/7-default.png);
            background-size: cover;

            &:hover {
              background: url(../assets/image/exam/7-hover.png);
              background-size: cover;
            }

            &:active {
              background: url(../assets/image/exam/7-selected.png);
              background-size: cover;
            }
          }

          .text-stress {
            background: url(../assets/image/exam/13-default.png);
            background-size: cover;

            &:hover {
              background: url(../assets/image/exam/13-hover.png);
              background-size: cover;
            }

            &:active {
              background: url(../assets/image/exam/13-selected.png);
              background-size: cover;
            }
          }

          .text-noStress {
            background: url(../assets/image/exam/14-default.png);
            background-size: cover;

            &:hover {
              background: url(../assets/image/exam/14-hover.png);
              background-size: cover;
            }

            &:active {
              background: url(../assets/image/exam/14-selected.png);
              background-size: cover;
            }
          }
        }
      }

      .tl-main {
        width: 100%;
        height: calc(100% - 46px);
        overflow-y: auto;
        font-size: 20px;
        line-height: 1.6;
        box-sizing: border-box;
        padding-left: 16px;

        .tl-main-title {
          font-weight: bold;
          font-size: 32px;
          line-height: 2;
        }

        .tl-note-title {
          font-weight: bold;
        }
      }
    }

    .top-left-scroll {
      width: 3px;
      height: 100%;
      cursor: col-resize;
    }

    .top-right {
      width: 50%;
      height: 100%;
    }
  }

  .main-bottom {
    height: 60px;
    background-color: #f6f6f6;
    display: flex;

    .bottom-left {
      display: flex;
      align-items: center;
      margin: 18px;

      .skin-btn {
        width: 30px;
        height: 30px;
        margin: 14px;
        cursor: pointer;
        border: 1px solid #d4d4d4;
        box-sizing: border-box;

        &:hover {
          border: 2px solid #9b9d9c;
        }

        &:active {
          border: 2px solid #d4d4d4;
        }

        &.skin1 {
          background-color: #ffffff;
        }

        &.skin2 {
          background-color: #cce9cf;
        }

        &.skin3 {
          background-color: #c1d3d6;
        }

        &.skin4 {
          background-color: #f4f1e9;
        }

        &.skin5 {
          background-color: #dce2f2;
        }

        &.skin6 {
          background-color: #f1e5c8;
        }
      }
    }

    .bottom-right {
      display: flex;
      flex-grow: 1;
      align-items: center;
      font-size: 18px;
      justify-content: flex-end;

      .que-but {
        font-size: 18px;
        padding: 7px 12px;
        border: 1px solid #1673be;
        background-color: #ffffff;
        color: #1673be;
        margin-right: 24px;
        user-select: none;
        cursor: pointer;

        &.finished {
          color: #ffffff;
          background-color: #1673be;
          border: 1px solid #1673be;
        }

        &.selected {
          color: #ffffff;
          background-color: #db5926;
          border: 1px solid #db5926;
        }

        &:hover {
          border: 1px solid #6db7eb;
        }

        &:active {
          border: 1px solid #cfcfcf;
        }
      }

      .prim-but {
        padding: 10px 20px;
        border: 1px solid #1d7ecc;
        border-radius: 4px;
        background-color: #1d7ecc;
        margin-right: 4px;
        margin-left: 20px;
        cursor: pointer;
        color: #ffffff;

        &:hover {
          background-color: #2081ce;
          border: 1px solid #2081ce;
        }

        &:active {
          background-color: #1d7ecc;
          border: 1px solid #1d7ecc;
        }
      }
    }
  }
}

.top-left,.top-left *,.top-left /deep/ *,.top-right /deep/ .tr-top,.top-right /deep/ .tr-top  *{font-family: 'TimesNewRoman';}
</style>